<template>
  <div class="container radar-page">
    <el-tabs v-model="activeName">
      <el-tab-pane label="AI追踪" name="ai">
        <ai-track v-if="activeName === 'ai'" />
      </el-tab-pane>
      <el-tab-pane label="行为分析" name="behavior">
        <behavior-analysis v-if="activeName === 'behavior'" />
      </el-tab-pane>
      <el-tab-pane label="成交率" name="closing">
        <closing-rate v-if="activeName === 'closing'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import AiTrack from './components/AiTrack'
import BehaviorAnalysis from './components/BehaviorAnalysis'
import ClosingRate from './components/ClosingRate'

export default {
  name: 'AcquisitionRadar',
  components: { AiTrack, BehaviorAnalysis, ClosingRate },
  data() {
    return {
      activeName: 'ai'
    }
  }
}
</script>

<style scoped lang="scss">
.radar-page {
  background: #fff;
  padding: 16px 24px;
  min-height: calc(100vh - 120px);
}
/deep/ .el-tabs__header {
  margin-bottom: 16px !important;
}
</style>
